"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mixpanel_browser_1 = __importDefault(require("mixpanel-browser"));
const mixpanel_1 = require("../utils/mixpanel");
const mixpanelPlugin = userConfig => {
    const projectToken = userConfig.token;
    const batchRequests = userConfig.batchRequests ?? true;
    let eventAttributes;
    let eventNames;
    let logger;
    const track = (eventName, attributes) => {
        const modifiedAttributes = (0, mixpanel_1.getMixPanelAttributes)(attributes ?? {});
        logger.debug(`Mixpanel: Sending Event to: ${eventName}`, modifiedAttributes);
        mixpanel_browser_1.default.track(eventName, modifiedAttributes);
    };
    return {
        name: 'mixpanel',
        initialize: ({ logger: loggerL, eventNames: eventNamesL, eventAttributeNames: eventAttributesL, }) => {
            mixpanel_browser_1.default.init(projectToken, { batch_requests: batchRequests });
            logger = loggerL;
            eventNames = eventNamesL;
            eventAttributes = eventAttributesL;
            logger.debug('Mixpanel: initialized');
        },
        trackEvent: (eventName, attributes) => {
            track(eventName, attributes);
            logger.debug(`Mixpanel: Event: ${eventName}`, attributes);
        },
        trackScreen(screenName, attributes) {
            track(eventNames.SCREEN_VIEW, {
                ...attributes,
                [eventAttributes.SCREEN_NAME]: screenName,
            });
        },
        trackClick(CTA, screenName, attributes) {
            track(eventNames.CLICK, {
                ...attributes,
                [eventAttributes.CTA]: CTA,
                [eventAttributes.SCREEN_NAME]: screenName,
            });
        },
        login(userId, userType) {
            if (userType === 'STUDENT') {
                mixpanel_browser_1.default.identify(`s:${userId}`);
            }
            else if (userType === 'TEACHER') {
                mixpanel_browser_1.default.identify(`t:${userId}`);
            }
            else if (userType === 'PARENT') {
                mixpanel_browser_1.default.identify(`p:${userId}`);
            }
            else if (userType === 'ADMIN') {
                mixpanel_browser_1.default.identify(`a:${userId}`);
            }
            else if (userType === 'CIRCLE') {
                mixpanel_browser_1.default.identify(`cs:${userId}`);
            }
            else {
                mixpanel_browser_1.default.identify(`uk:${userId}`);
            }
        },
        logout() {
            return null;
        },
        canTrackAllEvents: () => userConfig?.trackAllEvents ?? false,
    };
};
exports.default = mixpanelPlugin;
//# sourceMappingURL=mixpanel.js.map